import React, { Component } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ButtonIcon from "../../../button";
import { CheckBox } from "../../../common/custom-form/checkbox.component";

export class InvoiceRematch extends Component {
  constructor(props) {
    super(props);  
    this.onSelectedChange=this.onSelectedChange.bind(this);
    this.state={
      show:false,
      clearData:false, 
      selected:[],
      options:[
        { value: 'one', label: 'Option One' },
        { value: 'two', label: 'Option Two' },
    ],
      selectedTwo:[],
      CheckBoxValue:[
        "Currency Mismatch",
        "Fist Bill",
        "MRC Mismatch",
        "Invoice Total Mismatch",
        "Billing Start Date",
        "NRC Mismatch",
        "Invoice Percent",
        "Billing End Date",
        "Billing Account Mismatch",
        "Previous Balance",
        "High Spender",
        "Different Provider",
        "Previous Balance Percent",
        "Circuit Percent",
        "Disconnected",
        "Duplicate",
        "Order In Progress",
        "Deleted",
        "Unbilled Circuit",
        "Dispute In Process",
        "Circuit Not Found"
      ]
    }
  }

  handleClose(){
    this.setState({show:false});
  }

  handleShow() {
    this.setState({show:true});
  }

  onSelectedChange(selected) {
    this.setState({selected:selected})
  }

  onChange = (selected) => {
    this.setState({ selected });
  };
  
  resetClearData(item) {
    this.setState({clearData:item})
  }
 
  render(){
    const {show,selected,clearData }=this.state;
    return(
      <>

      <ButtonIcon onClick={this.handleShow.bind(this)} customClassName="header-filter-button" labelName="Rematch"/>
      
      <Modal
        show={show}
        onHide={this.handleClose.bind(this)}
        backdrop="static"
        keyboard={false}
        className="custom-column-modal-container modal-rematch"
      >
        <Modal.Header closeButton>
          <Modal.Title>Invoice Rematch</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <span className="checkbox-title">Audit Rules</span>
           <div className="checkbox-rematch-container">
                {this.state.CheckBoxValue.map((value,id)=>
                        <CheckBox key={id} label={value} />
                 )}
           </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose.bind(this)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={()=>alert("Click Me")}>Rematch & Extract</Button>
        </Modal.Footer>
      </Modal>

      </>
    );
  }
}
